import { STAGE } from './config';

type DataLayerEntry = {
	event: string;
	[key: string]: unknown;
};

type DataLayerWindow = Window & {
	dataLayer?: DataLayerEntry[];
};

export const isProductionStage = () => STAGE.toUpperCase() === 'PRODUCTION';

export const pushDataLayerEvent = (eventName: string) => {
	if (!isProductionStage() || typeof window === 'undefined') {
		return;
	}

	const win = window as DataLayerWindow;
	win.dataLayer = win.dataLayer || [];
	win.dataLayer.push({ event: eventName });
};
